<template>
  <div class="">
    <div class="content flex-r-center">
      <div class="card-width" v-loading="loading" element-loading-text="制作中请稍候">
        <!--          <div slot="header" class="card-wrap flex-center-center fz24">申领单位电子私章</div>-->
        <div class="order-area">
          <div class="order-detail">
            <div class="common-title">订单明细</div>
            <div class="flex-center-between mb5">
              <div class="order-name ml10" v-if="selectionSeal.sealType != 'ukey'">广烁电子印章管理与服务平台电子印章
              </div>
              <div class="order-name ml10" v-if="selectionSeal.sealType == 'ukey'">购买广烁电子签章客户端授权</div>
              <div class="order-price">￥{{ totalPrice }}</div>
            </div>
            <div class="order-item flex-center">
              <img src="@/assets/login/icon-seal-type.png" alt/>
              <div>印章类别：{{ selectionSeal.type.productName }}</div>
            </div>
            <div class="order-item flex-center">
              <img src="@/assets/login/icon-seal-num.png" alt/>
              <div>印章数量：{{ selectionSeal.seals.length }}枚</div>
            </div>
            <div class="order-item flex-center">
              <img src="@/assets/login/icon-time.png" alt/>
              <div>使用期限：1年</div>
            </div>
            <div class="order-item">
              <div class="flex-center">
                <img src="@/assets/login/icon-seal-cate.png" alt/>
                <div class="fz14">印章类型</div>
              </div>
              <el-row :gutter="20">
                <el-col :span="12" v-for="(item, index) in selectionSeal.seals" :key="index + 'select'">
                  <div class="type-item ta-l fc6 fz14" v-if="selectionSeal.sealType != 'ukey'">{{ item.name }}：￥{{
                    selectionSeal.type.productPrice
                    }}
                  </div>
                  <div class="type-item ta-l fc6 fz14" v-if="selectionSeal.sealType == 'ukey'">{{ item.name }}
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <!-- <div class="order-detail">
            <div class="common-title">
              联系地址
              <span class="info-color fz14">智能密码钥匙将在5-7个工作日内完成制作</span>
            </div>
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="type-item ta-l fc6 pl20 pr10 pb10">钥匙数量：{{ selectionSeal.length }}</div>
              </el-col>
              <el-col :span="12">
                <div class="type-item ta-l fc6 pl20 pr10 pb10">领取方式：邮寄</div>
              </el-col>
            </el-row>
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="120px"
              class="demo-ruleForm mt20"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item prop="name" label="联系人">
                    <el-input v-model="ruleForm.name" placeholder="请输入联系人"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="telephone" label="手机号码">
                    <el-input
                      type="number"
                      v-model="ruleForm.telephone"
                      :maxlength="11"
                      placeholder="请输入手机号码"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="name" label="所在地区">
                    <el-cascader
                      v-model="ruleForm.province"
                      :options="options"
                      :props="{ value: 'Code', label: 'Name', children: 'ChildList' }"
                      placeholder="请选择省、市、区"
                    ></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="name" label="门牌号">
                    <el-input v-model="ruleForm.name" placeholder="请输入小区楼栋/乡村名字"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div> -->
          <div class="price-detail">
            <div class="common-title">价格明细</div>
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="type-item ta-l fc6 fz14">商品总价(共{{ selectionSeal.seals.length }}枚电子印章)
                  ：{{ singlePrice }}元/枚*{{ selectionSeal.seals.length }}枚
                </div>
                <!--                          <div class="type-item ta-l fc6 fz14" v-if="selectionSeal.sealType == 'ukey'">商品总价(共{{ selectionSeal.seals.length }}枚电子印章)-->
                <!--                              ：UKEY授权{{ totalPrice }}-->
                <!--                          </div>-->
              </el-col>
              <!-- <el-col :span="12">
                <div class="type-item ta-l fc6 fz14">本地签署服务费：10元</div>
              </el-col> -->
              <el-col :span="12">
                <div class="type-item ta-l fc6 fz14">
                  合计：
                  <span style="color: #ff4742">{{ totalPrice }}元</span>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="button-area">
            <el-button class="button-cancel" @click="handlePay('wxpay')" v-if="totalPrice == 0">确认制作</el-button>
            <el-button class="button-cancel" @click="handlePay('wxpay')" v-if="totalPrice != 0">微信支付</el-button>
            <el-button type="primary" class="button-pay" @click="handlePay('alipay')" v-if="totalPrice != 0">
              支付宝支付
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <pay-dialog ref="payRef" :loadings.sync="loading"></pay-dialog>
  </div>
</template>
<script>
import PayDialog from "../components/PayDialog.vue";
import Province from "@/pages/register/components/Province.json";
import Cookie from "js-cookie";

export default {
  components: {PayDialog},
  data() {
    var validPhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === "") {
        callback(new Error("请输入实名手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入实名手机号码"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      activeIndex: 0,
      totalPrice: 0,
      singlePrice: 0,
      chosenData: {},
      options: Province,
      selectionSeal: {
        type: {},
        consigneeCacheId: '',
        seals: []
      },
      ruleForm: {
        name: undefined
      },
      rules: {
        name: [{required: true, message: "请输入联系人", trigger: "blur"}],
        telephone: [{required: true, validator: validPhone, trigger: "blur"}]
      }
    };
  },
  computed: {
    user() {
      return this.$store.state.account.user
    },
    isLogin() {
      return this.user && this.user.userId
    }
  },
  mounted() {
    this.selectionSeal = JSON.parse(sessionStorage.getItem('selection'))
    this.ukeySn = sessionStorage.getItem('ukeySn')
    if (!this.selectionSeal || !this.selectionSeal.seals || !this.selectionSeal.seals.length) {
      this.$alert('订单详细未知', '', {
        confirmButtonText: '确定',
        callback: () => {
          // this.$router.go(-1)
          this.$emit('update:type', 2)
        }
      });
      return
    }

    this.userId = this.$auth.getKqUserId() || this.user.userId
    this.businessCode = Cookie.get('businessCreditCode') || this.user.code

    this.singlePrice = this.selectionSeal.type.productPrice
    this.totalPrice = this.selectionSeal.seals.length * this.singlePrice
    if (this.selectionSeal.sealType == 'ukey') {
      this.totalPrice = this.selectionSeal.type.productPrice
    }


    console.log(this.selectionSeal)
  },
  methods: {
    handlePay(type) {
      this.createOrder(type)
    },
    createOrder(payType) {
      if (this.loading) return
      this.loading = true;

      let params = {
        payType: payType,
        userId: this.userId,
        businessCode: this.businessCode,
        agentName: Cookie.get('agentName'),
        agentIdCard: Cookie.get('agentIdCard'),
        consigneeCacheId: this.selectionSeal.consigneeCacheId,
        productId: this.selectionSeal.type.productId,
        buyCount: this.selectionSeal.seals.length,
        sealTypes: this.selectionSeal.seals.map(item => {
          return item.code
        }),
        uKeySn: this.selectionSeal.sealType == 'ukey' ? this.ukeySn : null,
      }

      console.log(params)

      this.$http.post(this.$api.customerEnterprise.createOrder, params).then(res => {
        if (res.data.code == 200 && res.data.data.tradeNo) {
          if (res.data.data.payStatus == '0') {
            let codeImg = "data:image/png;base64," + res.data.data.buyQrcode;
            let payChannel = payType === 'wxpay' ? '微信' : '支付宝';
            this.$refs.payRef.show(codeImg, payChannel, res.data.data.tradeNo, this.totalPrice);
          } else {
            let params = {
              tradeNo: res.data.data.tradeNo
            };
            this.$http.post(this.$api.register.doTrackTrade, params, {
              "Content-Type": "multipart/form-data"
            }).then(res => {
              if (res.data.code == 200) {
                setTimeout(() => {
                  this.loading = false;
                  this.$message.success('操作成功')
                  this.$router.push({path: "/customerEnterprise/list"});
                }, 5000)
              } else {
                this.loading = false;
                // 剩余制作次数不足，剩余制作次数：0
                this.$message.error(res.data.msg)
              }
            }).catch(err => {
              this.$message.error(err.msg)
              this.$router.push({path: "/customerEnterprise/list"});
            });
          }
        } else {
          this.loading = false;
          this.$message.error(res.data.msg || '支付创建失败');
        }
      });
    },
  }
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;

  .common-title {
    display: inline-block;
    width: 100%;
    margin: 10px 0;
    padding-left: 14px;
    position: relative;
    font-size: 18px;
    text-align: left;

    &:after {
      content: "";
      position: absolute;
      width: 4px;
      height: 18px;
      background: linear-gradient(0deg, #0d90ff, #00a1ff);
      left: 0;
      bottom: 50%;
      transform: translateY(50%);
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }

  .info-color {
    color: #faa000;
    margin: 0 5px;
  }

  .order-area {
    margin-left: 112px !important;
    margin-right: 112px !important;
  }

  .order-detail {
    .order-name {
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: bold;
    }

    .order-price {
      color: #ff4742;
      font-size: 20px;
    }

    .order-item {
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #eee;

      &:last-child {
        border-bottom: none;
      }

      img {
        width: 16px;
        height: 16px;
        margin-right: 10px;
      }
    }
  }

  .type-item {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #f1f1f1;
  }

  .price-detail-list {
    padding: 6px 5px 6px 9px;
    text-align: left;
    border-bottom: 1px solid #eee;

    .total-price {
      margin-left: 50px;
    }
  }

  .button-area {
    margin-top: 55px;

    .button-cancel {
      width: 200px !important;
      margin-right: 50px !important;
      border: 1px solid #407fff;
      font-size: 16px !important;
      color: #407fff;
    }

    .button-pay {
      width: 200px !important;
      margin-left: 10px;
      box-shadow: 0 2px 4px 0 rgba(64, 129, 255, 0.4);
      font-size: 16px !important;
    }
  }
}

::v-deep .el-card {
  width: 1200px;
  min-height: 730px;
}

::v-deep .el-card__body {
  padding: 20px 20px 30px;
}
</style>
